import type { ISetting, ISettingValueMaster } from "@bbj-types/setting";
import { buildMakeUseAxios } from "@root/api/api.tools";
import { useCallback } from "react";

const axios = buildMakeUseAxios(`${import.meta.env.VITE_SETTING_SERVICE_URL}/settings`);

interface IGetPublicInitSettingsParams {
  settings: { domain: string[]; settingType: string[] };
  organisation: string;
}

type TGetPublicInitSettings = (ISetting & { values: ISettingValueMaster[] })[];

export const useGetPublicInitSettings = () => {
  const [state, execute, cancel] = axios<TGetPublicInitSettings, IGetPublicInitSettingsParams, unknown>(
    {
      url: "/public/init",
      method: "POST",
    },
    { manual: true, useCache: false }
  );

  const callback = useCallback(
    (data: IGetPublicInitSettingsParams) => {
      return execute({ data });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
